import { createContext, useContext, useLayoutEffect, useState, type ReactNode } from "react";

type ThemeMode = "light" | "dark";
type ThemeContextValue = { theme: ThemeMode; toggleTheme: () => void };

const STORAGE_KEY = "tg-checkin-theme";
const ThemeContext = createContext<ThemeContextValue>({ theme: "light", toggleTheme: () => {} });

function readTheme(): ThemeMode {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<ThemeMode>(readTheme);

  useLayoutEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // 禁用浏览器存储时，主题仍在当前页面生效。
    }
  }, [theme]);

  return <ThemeContext.Provider value={{ theme, toggleTheme: () => setTheme((current) => current === "light" ? "dark" : "light") }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
